import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Alert, Box, DataSuspense, ToggleToScreenSize } from '@ztechapps/webui.util'
import { LoadingShippingRates } from './LoadingShippingRates'
import { TableLayout } from './table-layout'
import { MobileLayout } from './mobile-layout'
import { useCheckoutContext } from '../../index'
import { useShippingRatePanelContext } from './Context'

export const Layout = () => {
  const context = useCheckoutContext()
  const components = context.components
  const shippingRateContext = useShippingRatePanelContext()
  const [groupedByCarrier, { loading }] = shippingRateContext.groupedByCarrierRate
  return (
    <Box>
      <Box.Body>
        <div>
          <Alert type="info">
            This is just an estimate. Shipping costs vary depending on a variety of factors, from package measurements,
            shipment type, weight, location, and more. Amount is subject to change.
          </Alert>
        </div>

        <DataSuspense
          loading={loading}
          isEmpty={isEmpty(groupedByCarrier) && !loading} //we need extra check if loading
          emptyComponent={<components.shippingRateEmptyResult />}
          loadingComponent={<LoadingShippingRates />}
        >
          <ToggleToScreenSize mobile={MobileLayout} desktop={TableLayout} />
        </DataSuspense>
      </Box.Body>
    </Box>
  )
}
